// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__s9CuR","file":"styles_file__2hSgl"};